/* Website integration for the separate Library edition. No commerce adapter. */
(()=>{'use strict';
const root=document.querySelector('[data-dd-library-edition="30.1"]');
const node=document.getElementById('dd-digital-config');if(!root||!node)return;
const cfg=JSON.parse(node.textContent),script=document.currentScript;
cfg.activityScript=script.dataset.ddLibraryActivity;
cfg.cubeCommerceScript=null;
node.textContent=JSON.stringify(cfg);
window.CUBERUN_CONFIG=Object.assign({},window.CUBERUN_CONFIG,{experience:'library',mode:'live',showCode:false});
})();
